import React from 'react'
import { useSelector } from 'react-redux'
import { findSectionByIdentifier } from 'lib/pages/api'
import SectionType from 'models/types/ts/sectionType'
import LanguageType from 'models/language-type'
import { GlobalState } from 'types'
import {
    isLoggedIn,
    getLoggedInJwt,
} from '../../packages/authentication/lib/selectors'
import Recruit from './components/recruit'

interface Props {
    sections: Array<SectionType>
    language: LanguageType
}

const RecruitContainer = ({ sections, language }: Props): JSX.Element => {
    const loggedIn = useSelector((state: GlobalState) => isLoggedIn(state))
    const token = useSelector((state: GlobalState) => getLoggedInJwt(state))

    let hasContent = false
    if (sections) {
        hasContent = true

        const hero = findSectionByIdentifier(sections, 'recruit-hero')

        const socialShare = findSectionByIdentifier(
            sections,
            'recruit-social-share'
        )

        const howItWorks = findSectionByIdentifier(
            sections,
            'recruit-how-it-works'
        )
        const recruiterRewards = findSectionByIdentifier(
            sections,
            'recruit-rewards'
        )
        const recruiterBenefits = findSectionByIdentifier(
            sections,
            'recruit-benefits'
        )

        return (
            <Recruit
                loggedIn={loggedIn}
                token={token}
                language={language}
                hero={hero}
                socialShare={socialShare}
                howItWorks={howItWorks}
                recruiterRewards={recruiterRewards}
                recruiterBenefits={recruiterBenefits}
                hasContent={hasContent}
            />
        )
    }

    return <></>
}

export default RecruitContainer
